<div class="spinner-border" role="status">
  <span class="visually-hidden"></span>
</div>
